import { postRequest } from '../../../shared/utils';

export async function UserIdentitiesMutation({
  usersOperationDoc,
  usersMutationVariables,
  configSchema,
  pcnrMutationVariables,
  userstopcnrOperationDoc,
}) {
  try {
    const response = await postRequest(`/api/userIdentitiesUserOperation`, {
      usersOperationDoc,
      usersMutationVariables,
    });
    if (response.errors) {
      throw response.errors;
    }
    const id = response[`insert_${configSchema}_mbd_users`].returning[0].id;
    pcnrMutationVariables.userstopcnr_objects.forEach((obj) => (obj['user_id'] = id));

    const mutationResult = await postRequest(`/api/userIdentitiesPcnrOperation`, {
      userstopcnrOperationDoc,
      pcnrMutationVariables,
    });
    if (mutationResult.errors) {
      throw mutationResult.errors;
    }

    return { mutationResult };
  } catch (errors) {
    console.error('Mutation Service: ', errors?.[0]?.message ? errors?.[0]?.message : errors);
    return { errors };
  }
}
